import { Button } from "../atoms/button";

export const CourseCountAndButton = (props) => {
    const { course, onClick, label } = props;
    return (
        <>
            {/* <p style={style.courseCount}>該当コース<span style={styles.span}> {course} </span>件</p> */}
            <div className={"popupSearchBtnArea"}>
                <Button className={"popupSearchBtn"} onClick={onClick} buttonText={label} />
            </div>
        </>
    );
}
const styles = {
    span: {
        fontSize: "25px",
        fontWeight: "bold",
    },
}